import Box from "@mui/material/Box";
import {useTheme} from "../../contexts/theme";
import axiosInstance from "../../queries/axiosInstance";
import React, {useState} from "react";
import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import GroupClip from "./GroupClip";
import Grid from "@mui/material/Grid";
import VideoJSPlayer from "../CommonComponents/VideoJSComponent/VideoJSPlayer";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";
import {useActiveFilters} from "../../contexts/activeFilters";
import {useClipMamSelected} from "../../contexts/clipMamSelected";
import ErrorSnackBar from "../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {deleteClipGroupPlatform, deleteClipPlatform, getGroupClips} from "../../queries/mamPageQueries";
import ContentCardSkeleton from "./ContentCardSkeletonComponent/ContentCardSkeleton";
import CustomPagination from "../CommonComponents/CustomPagination/CustomPagination";
import {clipGroupPageSize} from "../../utils/constants";
import {sortByCustomOrderThenDate} from "../../utils/utilsClip";

interface GroupClipContainerProps {
    event_id: string;
    matchDay_id: string;
    loadingGruopClips: boolean
    competition_id: string;
}


export default function GroupClipContainer({event_id , matchDay_id, loadingGruopClips, competition_id}: GroupClipContainerProps){

    const theme = useTheme();

    const {information} = useMamInformation();
    const {setInformation} = useMamInformation();
    const {setDeleteLoading, setUpdateLoading} = useMamInformation();
    const {activeFilters} = useActiveFilters();
    const [numberSkeleton, setNumberSkeleton] = useState<Number[]>(new Array(12).fill(0));
    const [loadClip, setLoadClip] = useState<boolean>(false);
    const [selectedGroupId, setSelectedGroupId] = useState<string>("");


    const {addClips, removeClips, aspectRatio, setClipState, deleteSpecificClips} = useClipMamSelected();

    const {clips} = useClipMamSelected();

    const {summary} = useMamSummary();
    const {setSummary} = useMamSummary();
    const {pagesSummary, setGroupClipPage } = useMamSummary()

    const [openVideoPlayer, setOpenVideoPlayer] = useState<boolean>(false);
    const [videPlayerUrl, setVideoPlayerUrl] = useState<string>("");

    async function onPageChange(page: number){
        setGroupClipPage(event_id, page, clipGroupPageSize);
        const groupClipsPagination = await getGroupClips(competition_id, matchDay_id, event_id, activeFilters, page, clipGroupPageSize);
        const tempInformation = {...information!};

        if (tempInformation.clipGroups) {
            tempInformation.clipGroups = groupClipsPagination
            setInformation(tempInformation)
        }

    }

    const [errorMessage, setErrorMessage] = useState<{state: boolean, msg: string}>({
        state: false,
        msg: ""
    })

    const addClipGroups =  (idClip: string) => {
        const item = information?.clipGroups.find(item => item.id === idClip);

        const clipOnDragDrop = clips.filter(item => item.groupId === idClip)

        if(clipOnDragDrop.length > 0) {
            removeClips(clipOnDragDrop);
        }else {
            getClipOnDemand(item.competition, event_id, item.id, true).then(response => {
                if (response && response.length > 0)
                    addClips(response);
                else
                    setErrorMessage({
                        state: true,
                        msg: "There are no clips with this format"
                    });
            })
        }
    }



    const handleVideoPlayerUrl = (url: string) => {
        setVideoPlayerUrl(url);
    }

    const handleOpenVideoPlayerUrl = (open: boolean) => {
        setOpenVideoPlayer(open);
    }

    const handleCloseVideoPlayer = () => {
        setOpenVideoPlayer(false);
        setVideoPlayerUrl("")
    };

    const deleteclipGroup = (idClipGroupId: string) => {
        const tempInformation = {...information!};
        if (tempInformation.clipGroups ) {
            setDeleteLoading(true)
            deleteClipGroupPlatform(idClipGroupId).then(response => {

                const temp = tempInformation.clipGroups.find(item => item.id === idClipGroupId)
                if (temp) {
                    tempInformation.clipGroups.splice(tempInformation.clipGroups.indexOf(temp), 1);
                }

                const tempClipsSelected = clips.filter(item => item.groupId !== idClipGroupId);
                if (tempClipsSelected) {
                    setClipState(tempClipsSelected);
                }

                setInformation(tempInformation);

                if (response.msg !== 0){
                    setErrorMessage({
                        state: true,
                        msg: "Delete Successfully"
                    });
                }

            }).finally(() => setDeleteLoading(false))


        }

    }




    const deleteClip = (idClip: string) => {
        const tempInformation = {...information!};
        setDeleteLoading(true)
        if (tempInformation.clip) {

            deleteClipPlatform(idClip).then(response => {
                const temp = tempInformation.clip.find(item => item.id === idClip);
                if (temp) {
                    tempInformation.clip.splice(tempInformation.clip.indexOf(temp), 1);
                }


                if (clips.find(item => item.id === idClip)) {
                    deleteSpecificClips(idClip);
                }




                setInformation(tempInformation);

                if (response.msg === 'ok'){
                    setErrorMessage({
                        state: true,
                        msg: "Delete Successfully"
                    });
                }
            }).finally(() => setDeleteLoading(false))


        }
    }



    const getClipOnDemand = async (competition: string, event_id: string, group_id: string, filterWithAspectRatio?: boolean) => {
        try {
            setUpdateLoading(true);
            const response = await axiosInstance.post('/assets/clips', {
                competition: competition,
                matchDay: matchDay_id,
                event: event_id,
                filters: activeFilters,
                groupId: group_id
            });

            let result;
            if (filterWithAspectRatio) {
                result = response.data.filter((item:any) => item.aspect_ratio === aspectRatio);
            }





            return result ? result: response.data;
        } catch (errorCompetition) {
            console.error("Error retrieve events", JSON.stringify(errorCompetition));
        }finally {
            setUpdateLoading(false)
        }
    }

    const onCollapseClipsGroupOpen = (competition: string, event_id: string, clipGroup_id: string, openEvent: boolean) => {
        const tempSummary = {...summary};
        const sortOrder = {
            "16:9": 0,
            "9:16": 1,
            "4:5": 2,
            "1:1": 3
        };

        if (openEvent){
            tempSummary.groupClip = tempSummary.groupClip.filter(item => item !== selectedGroupId);
            setSelectedGroupId("");
        }else {
            setSelectedGroupId(clipGroup_id);
            if (!tempSummary.groupClip.find(item => item === clipGroup_id)) {
                const groupClip = [...tempSummary.groupClip];
                groupClip.push(clipGroup_id);
                tempSummary.groupClip = groupClip;
            }
            setLoadClip(true);
            getClipOnDemand(competition, event_id, clipGroup_id).then(response => {

                if (response) {
                    const tempInformation = {...information!};
                    response = sortByCustomOrderThenDate(response,
                        'aspect_ratio',
                        'generate_at',
                        sortOrder,
                        'desc' )



                    if (tempInformation.clip) {
                        response.map((item: any) => {
                            if (!tempInformation.clip!.find(value => value.id === item.id)) {
                                tempInformation.clip!.push(item);
                            }
                        })
                        setInformation(tempInformation)
                    }

                }else{
                    setErrorMessage({
                        state: true,
                        msg: "Error retrieving clips"
                    })
                }
                setLoadClip(false);
            })


        }

        setSummary(tempSummary);
    }


    return (
        <Box sx={{
            padding: theme.spacing.md,
        }}
        >

            <ErrorSnackBar  autoHideDuration={2000} open={errorMessage.state} setClose={() => {setErrorMessage(
                {
                    state: false,
                    msg: ""
                }
            )}} errorMessage={errorMessage.msg} />


            <StyledPopup
                isOpen={openVideoPlayer}
                onClose={handleCloseVideoPlayer}
                height="92vh"
                width="calc((87vh/9)*16)"
            >
                <VideoJSPlayer url={videPlayerUrl} sourceType={'video/mp4'}/>
            </StyledPopup>
            <CustomPagination page={pagesSummary.groupClip[event_id] ? pagesSummary.groupClip[event_id].number : 0} onPageChange={onPageChange} disableArrowRight={Boolean(information && information?.clipGroups.length < clipGroupPageSize)}></CustomPagination>
            <Grid container spacing={2} direction="row">

                {loadingGruopClips ?
                    (
                            numberSkeleton.map((item, index) => (
                                    <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
                                <ContentCardSkeleton/>
                                    </Grid>
                            ))
                    ) : (
                        information?.clipGroups && information?.clipGroups?.filter(item => item.event_id === event_id).map((item, index) => (
                            <Grid key={index} item xl={2} lg={3} md={4} sm={6} xs={12}>
                                <GroupClip selectedGroupClipdId={selectedGroupId} groupClip={item} handleOpenVideoPlayerUrl={handleOpenVideoPlayerUrl} handleVideoPlayerUrl={handleVideoPlayerUrl} deleteGroupClip={deleteclipGroup} onCollapseClipsGroupOpen={onCollapseClipsGroupOpen} deleteClip={deleteClip} addClipGroup={addClipGroups} loadClip={loadClip} />
                            </Grid>
                        ))
                    )

                }

            </Grid>
        </Box>
    )
}